export const MULTI_PART_ANSWER_SCREEN_REACHED = 'MULTI_PART_ANSWER_SCREEN_REACHED';

export const TRIGGER_MULTI_PART_QUESTION_TUTORIAL = 'TRIGGER_MULTI_PART_QUESTION_TUTORIAL';

export const MULTI_PART_QUESTION_TUTORIAL_DISMISSED = 'MULTI_PART_QUESTION_TUTORIAL_DISMISSED';

/**
 * Register that the user has reached the answer screen for a multi-part
 * question with more than 1 part and therefore is eligible to see the
 * multi-part-question tutorial
 */
export function multiPartAnswerScreenReached() {
    return { type: MULTI_PART_ANSWER_SCREEN_REACHED };
}

/**
 * Trigger the multi-part question tutorial, registering the attemptId for
 * the question
 * @param attemptId
 */
export function triggerMultipartQuestionTutorial(attemptId) {
    return { type: TRIGGER_MULTI_PART_QUESTION_TUTORIAL, attemptId };
}

/**
 * Register that the user has dismissed the multi-part question tutorial. This
 * will not show the tutorial again until the user either completes it by
 * answering a question, or leaves the question and returns.
 */
export function multiPartQuestionTutorialDismissed() {
    return { type: MULTI_PART_QUESTION_TUTORIAL_DISMISSED };
}
